import {Component} from 'react'
import Trash from 'react-feather/dist/icons/trash.js'
import {toastr} from 'react-redux-toastr'
import {Link} from 'react-router-dom'

import LanguageForm from '../../../../components/Forms/LanguageForm/LanguageForm.jsx'
import Loader from '../../../../../shared/components/Loader/Loader.jsx'

import api from '../../../../../api.js'
import conf from '../../../../conf.js'
import {generate} from '../../../../routes.js'
import handleResponseErrors from '../../../../services/processServerErrors.js'
import FreelancePage from "../../../../../shared/components/Styled/Containers/FreelancePage.jsx"

export default class Languages extends Component {
  constructor(props) {
    super(props)
    this.state = {
      updating: false,
      loading: false,
      languages: props.freelance?.languages || [],
      languageLevels: Object.values(conf.languageLevels).reduce(
        (acc, curr) => {
          acc[curr.value] = curr.label
          return acc
        },
        []
      )
    }
  }

  addLanguage = () => {
    return async (values) => {
      this.setState({updating: true})
      const newLanguage = {
        language: values.language[0].id,
        name: values.language[0].name,
        level: values.level
      }

      const languages = [...this.state.languages]

      if (languages.some(lang => lang.language === newLanguage.language)) {
        this.setState({updating: false})
        return toastr.error('Ce langage est déjà renseigné')
      }

      try {
        await api.freelanceLanguages.add({
          freelance: this.props.freelance.id,
          language: newLanguage.language,
          level: newLanguage.level
        })

        this.setState({languages: [...languages, newLanguage]})
      } catch (e) {
        handleResponseErrors(e)
      } finally {
        this.setState({updating: false})
      }
    }
  }

  removeLanguage = (offset) => {
    return async () => {
      this.setState({updating: true})
      const languages = [...this.state.languages]
      const [removed] = languages.splice(offset, 1)

      try {
        await api.freelanceLanguages.delete({
          freelance: this.props.freelance.id,
          language: removed.language
        })

        this.setState({languages})
      } catch (e) {
        console.warn(e)
      } finally {
        this.setState({updating: false})
      }
    }
  }

  save = async () => {
    this.setState({loading: true})
    try {
      await this.props.submit({
        user: this.props.user,
        freelance: this.props.freelance,
      })
    } catch (e) {
      console.warn(e)
    } finally {
      this.setState({loading: false})
      this.props.onFormSuccess()
    }
  }

  render() {
    const {languages} = this.state

    return (
      <FreelancePage className="p-5">
        <div className="step-upload-cv">
          <h2 className="text-center">Langues</h2>
          <p className="text-center mb-5">
            Indiquez nous vos capacités à vous exprimer dans les langues que vous pratiquez
          </p>

          <div className="text-center mt-5 mb-4">
            <h4>Mes langues</h4>
          </div>
          <LanguageForm onSubmit={this.addLanguage()}/>
          <div className="languages">
            {languages.map((language, index) => (
              <div key={index} className="callout d-inline-block mr-3 mt-0 mb-3">
                <b className="text-capitalize">{language.name}</b> - {this.state.languageLevels[language.level]}
                <button onClick={this.removeLanguage(index)} type="button"
                  className="btn btn-round btn-sm btn-outline-danger ml-3">
                  <Trash/>
                </button>
              </div>
            ))}
          </div>

          {!this.props.edit &&
          <div className="mt-5 d-flex flex-wrap align-items-center">
            <div className="mr-auto">
              <Link to={generate({name: 'homepage'})} className="gray">
                Je finirai plus tard (ne pas sauvegarder)
              </Link>
            </div>
            <button type="button" onClick={this.save} className="btn btn-primary ml-auto">Étape suivante</button>
          </div>}
        </div>
        <Loader visible={this.state.updating}>
          Modification en cours...
        </Loader>
        <Loader visible={this.state.loading}>
          Sauvegarde en cours...
        </Loader>
      </FreelancePage>
    )
  }
}
